var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no_page" }, [
    _c("img", {
      staticClass: "no-pic",
      attrs: { src: _vm.pic, alt: "no data" },
    }),
    _c("br"),
    _c("span", { staticClass: "no-tip" }, [
      _vm._v(_vm._s(_vm.$t("house.picTip"))),
    ]),
    _c("form", { attrs: { id: "uploadImg" } }, [
      _c(
        "div",
        { staticClass: "form-box margin-bottom-20" },
        [
          _c(
            "Button",
            {
              staticClass: "upload-btn file",
              attrs: { type: "primary", size: "large" },
            },
            [
              _vm._v(_vm._s(_vm.$t("house.upload")) + " "),
              _c("input", {
                attrs: {
                  type: "file",
                  name: "facePic",
                  accept: ".jpg,.jpeg",
                  multiple: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.showPic($event)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]),
    _c("form", { attrs: { id: "uploadLog" } }, [
      _c(
        "div",
        { staticClass: "form-box" },
        [
          _c(
            "Button",
            {
              staticClass: "btn-margin file",
              attrs: {
                size: "large",
                icon: "ios-cloud-download-outline",
                type: "primary",
                ghost: "",
              },
            },
            [
              _vm._v(_vm._s(_vm.$t("house.input")) + " "),
              _c("input", {
                attrs: {
                  type: "file",
                  name: "uploadLog",
                  accept: "text/xml, application/xml",
                },
                on: {
                  change: function ($event) {
                    return _vm.writeLog($event)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]),
    _c("span", { staticClass: "add-tip" }, [
      _vm._v(_vm._s(_vm.$t("house.sendTip"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }